import styled from 'styled-components';
import Button from '../CommonComponents/Button';
import {darken} from "polished";

export const EmptyStateBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #e3e1e1;
  border-radius: ${props => props.theme.legacy.borderRadius};
  background: #ffffff;
  color: #4a4a4a;
  padding: 50px 30px;
  flex: 1;
  @media (max-width: 415px) {
    flex: 1 1 100%;
    flex-flow: column;
    padding: 30px 20px;
  }
`;

export const EmptyStateHeaderWrapper = styled.div`
  max-width: 100%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: space-between;
`;

export const EmptyStateHeader = styled.h3`
  font-weight: 600;
  margin: 0 0 30px 0;
  @media (max-width: 415px) {
    margin: 0 0 10px 0;
  }
`;

export const EmptyStateBody = styled.p`
  margin: 0;
  max-width: 100%;

  @media (max-width: 415px) {
    text-align: center;
    margin-bottom: 16px;
  }
`;

export const EmptyStateButton = styled(Button)`
  height: auto;
  line-height: normal;
  color: #ffffff;
  background: ${props => props.theme.legacy.colors.brand || '#0078D4'};
  padding: 20px 0;
  border-radius: 4px;
  width: 230px;
  transition: 0.2s all ease-in-out;

  &:hover,
  &:focus,
  &:active {
    background: ${({ theme }) => darken(0.1, theme.legacy.colors.brand || '#1960A6')} !important;
    text-shadow: none !important;
    transition: 0.2s all ease-in-out;
  }

  @media (max-width: 415px) {
    border-radius: 24px;
    padding: 0;
    height: 48px;
  }
`;

export const EmptyStateImage = styled.img`
  width: 200px;
`;
